import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
// Editorial serif for cinematic moments — the Brief greeting, page
// titles, focus-session block titles. Loaded eagerly so the typography
// doesn't shift on first paint; the file is small (~6KB woff2 per weight).
import '@fontsource/newsreader/400.css';
import '@fontsource/newsreader/500.css';
import '@fontsource/newsreader/600.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister the PWA service worker. The previous register() flow cached the
// SPA bundle aggressively but only *logged* "please refresh" when a new
// bundle deployed — meaning users stayed on stale bundles indefinitely. That
// broke the OAuth roll-out: clients that loaded the SPA before the
// /oauth/authorize route shipped were silently bouncing to the dashboard
// because the cached bundle's Routes catch-all didn't know the new path.
// Unregistering here forces a clean fetch on every reload. Re-enable with
// a proper update-and-skipWaiting flow when offline support is needed.
serviceWorkerRegistration.unregister();

// Core Web Vitals — posts LCP / CLS / FID / FCP / TTFB to
// /api/diagnostics/web-vitals when the backend is reachable. Observational
// only; failures are swallowed.
reportWebVitals();
